export const CardOnFileFormConstants = {
    FIRST_NAME_MAX_LENGTH: 50,
    LAST_NAME_MAX_LENGTH: 50,
    COMPANY_MAX_LENGTH: 50,
    ADDRESS_MAX_LENGTH: 60,
    CITY_MAX_LENGTH: 40,
    ZIP_MAX_LENGTH: 20,
    CARD_CODE_MASTERCARD_VISA_LENGTH: 3,
    CARD_CODE_AMEX_LENGTH: 4,
} as const;
